import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { label: 'About', type: 'scroll', id: 'about' },
  { label: 'Programmes', type: 'route', path: '/programmes' },
  { label: 'Why Trees', type: 'route', path: '/tree-benefits' },
  { label: 'Blog', type: 'route', path: '/blog' },
  { label: 'Gallery', type: 'route', path: '/gallery' },
  { label: 'Contributors', type: 'route', path: '/contributors' },
  { label: 'Collaboration', type: 'route', path: '/collaboration' },
  { label: 'Contact', type: 'scroll', id: 'contact' },
];

export default function PublicNavbar() {
  const [navSolid, setNavSolid] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => setNavSolid(window.scrollY > 60);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const handleNavClick = useCallback((item) => {
    setMobileMenuOpen(false);
    if (item.type === 'route') {
      navigate(item.path);
    } else if (item.type === 'scroll') {
      if (location.pathname === '/') {
        const el = document.getElementById(item.id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        navigate('/', { state: { scrollTo: item.id } });
      }
    }
  }, [location.pathname, navigate]);

  return (
    <>
      <nav
        className="public-nav"
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
          padding: '14px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          background: navSolid ? 'rgba(27,94,32,0.97)' : 'transparent',
          backdropFilter: navSolid ? 'blur(10px)' : 'none',
          boxShadow: navSolid ? '0 2px 20px rgba(0,0,0,0.15)' : 'none',
          transition: 'all 0.35s ease',
        }}
      >
        <div
          style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}
          onClick={() => {
            if (location.pathname === '/') window.scrollTo({ top: 0, behavior: 'smooth' });
            else navigate('/');
          }}
        >
          <img src={`${process.env.PUBLIC_URL || ''}/haritanjali_logo.png`} alt="Haritanjali" style={{ width: 52, height: 52, objectFit: 'contain' }} />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: 22, fontWeight: 800, color: '#ffffff', lineHeight: 1.1 }}>हरितांजलि</span>
            <span style={{ fontSize: 8, color: 'rgba(255,255,255,0.85)', letterSpacing: 3, textTransform: 'uppercase', fontWeight: 600, marginTop: 1 }}>HARITANJALI</span>
            <span style={{ fontSize: 9, color: '#F5A623', fontStyle: 'italic', marginTop: 1 }}>जहाँ पेड़, वहाँ जीवन</span>
          </div>
        </div>

        {/* Desktop nav */}
        <div className="desktop-nav-links" style={{ display: 'flex', alignItems: 'center', gap: 28 }}>
          {navItems.map(item => (
            <button
              key={item.label}
              onClick={() => handleNavClick(item)}
              style={{
                background: 'none', border: 'none', color: (item.type === 'route' && location.pathname === item.path) ? '#ff9800' : 'white',
                fontSize: 15, fontWeight: 500, cursor: 'pointer',
                padding: '6px 0', position: 'relative', transition: 'color 0.2s',
              }}
              onMouseEnter={e => e.target.style.color = '#ff9800'}
              onMouseLeave={e => { if (!(item.type === 'route' && location.pathname === item.path)) e.target.style.color = 'white'; }}
            >
              {item.label}
            </button>
          ))}
          <div style={{ display: 'flex', gap: 10, marginLeft: 12 }}>
            <Link to="/login" className="btn" style={{
              background: 'transparent', border: '2px solid rgba(255,255,255,0.6)',
              color: 'white', borderRadius: 24, padding: '8px 22px', fontSize: 14, fontWeight: 600, transition: 'all 0.2s',
            }}>Login</Link>
            <Link to="/register" className="btn" style={{
              background: '#ff9800', color: '#fff', border: '2px solid #ff9800',
              borderRadius: 24, padding: '8px 22px', fontSize: 14, fontWeight: 600, transition: 'all 0.2s',
            }}>Register</Link>
          </div>
        </div>

        {/* Mobile hamburger */}
        <button
          className="mobile-hamburger"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{ display: 'none', flexDirection: 'column', gap: 5, background: 'none', border: 'none', cursor: 'pointer', padding: 4 }}
        >
          <span style={{ width: 26, height: 2, background: 'white', borderRadius: 2, transition: 'all 0.3s', transform: mobileMenuOpen ? 'rotate(45deg) translateY(7px)' : 'none' }} />
          <span style={{ width: 26, height: 2, background: 'white', borderRadius: 2, transition: 'all 0.3s', opacity: mobileMenuOpen ? 0 : 1 }} />
          <span style={{ width: 26, height: 2, background: 'white', borderRadius: 2, transition: 'all 0.3s', transform: mobileMenuOpen ? 'rotate(-45deg) translateY(-7px)' : 'none' }} />
        </button>
      </nav>

      {/* Mobile menu overlay + panel */}
      <div className={`mobile-nav-overlay ${mobileMenuOpen ? 'open' : ''}`} onClick={() => setMobileMenuOpen(false)} />
      <div className={`mobile-nav-panel ${mobileMenuOpen ? 'open' : ''}`}>
        <div style={{ marginBottom: 32 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src={`${process.env.PUBLIC_URL || ''}/haritanjali_logo.png`} alt="Haritanjali" style={{ width: 48, height: 48, objectFit: 'contain' }} />
            <div>
              <div style={{ fontSize: 20, fontWeight: 800, color: 'white', lineHeight: 1.1 }}>हरितांजलि</div>
              <div style={{ fontSize: 8, color: 'rgba(255,255,255,0.7)', letterSpacing: 2, textTransform: 'uppercase', fontWeight: 600, marginTop: 1 }}>HARITANJALI</div>
              <div style={{ fontSize: 10, color: '#F5A623', fontStyle: 'italic', marginTop: 2 }}>जहाँ पेड़, वहाँ जीवन</div>
            </div>
          </div>
        </div>
        {navItems.map(item => (
          <button
            key={item.label}
            onClick={() => handleNavClick(item)}
            style={{
              display: 'block', width: '100%', textAlign: 'left',
              background: 'none', border: 'none', color: 'rgba(255,255,255,0.85)',
              fontSize: 16, padding: '14px 0', cursor: 'pointer',
              borderBottom: '1px solid rgba(255,255,255,0.1)',
            }}
          >{item.label}</button>
        ))}
        <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <Link to="/login" onClick={() => setMobileMenuOpen(false)} style={{ display: 'block', textAlign: 'center', padding: '10px 0', border: '2px solid rgba(255,255,255,0.5)', borderRadius: 24, color: 'white', fontWeight: 600 }}>Login</Link>
          <Link to="/register" onClick={() => setMobileMenuOpen(false)} style={{ display: 'block', textAlign: 'center', padding: '10px 0', background: '#ff9800', borderRadius: 24, color: 'white', fontWeight: 600 }}>Register</Link>
        </div>
      </div>
    </>
  );
}
